/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Settings_Apikeys_Name_ColInputs */

const en_settings_apikeys_name_col = /** @type {(inputs: Settings_Apikeys_Name_ColInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Name`)
};

const zh_settings_apikeys_name_col = /** @type {(inputs: Settings_Apikeys_Name_ColInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`名称`)
};

/**
* | output |
* | --- |
* | "Name" |
*
* @param {Settings_Apikeys_Name_ColInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const settings_apikeys_name_col = /** @type {((inputs?: Settings_Apikeys_Name_ColInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Apikeys_Name_ColInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_settings_apikeys_name_col(inputs)
	return zh_settings_apikeys_name_col(inputs)
});
export { settings_apikeys_name_col as "settings.apikeys.name_col" }